import { render } from "./PixCnpjModal.vue?vue&type=template&id=cb84a13c&scoped=true"
import script from "./PixCnpjModal.vue?vue&type=script&lang=js"
export * from "./PixCnpjModal.vue?vue&type=script&lang=js"

import "./PixCnpjModal.vue?vue&type=style&index=0&id=cb84a13c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb84a13c"]])

export default __exports__